import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useModal } from '@/contexts';
import { useI18n } from '@/i18n';

const TeachCTASection: React.FC = () => {
  const { openTutorRegistration } = useModal();
  const { locale } = useI18n();
  const isZh = locale === 'zh-CN';

  return (
    <section className="bg-[#F6D15B] py-12 md:py-14">
      <div className="container mx-auto max-w-6xl px-4 md:px-8 lg:px-12 xl:px-16">
        <div className="mx-auto flex w-full max-w-2xl flex-col items-start gap-6 text-left">
          <h2 className="max-w-2xl text-3xl font-bold leading-tight tracking-tight text-black md:text-4xl">
            {isZh ? '今天就开始建立你的补习收入。' : 'Start building your tutoring income today.'}
          </h2>

          <button
            onClick={() => openTutorRegistration()}
            className="inline-flex min-h-12 cursor-pointer items-center justify-center gap-2 rounded-2xl bg-black px-7 py-3.5 text-base font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#1F1F1F] hover:shadow-[0_18px_36px_rgba(0,0,0,0.2)] focus:outline-none focus-visible:ring-2 focus-visible:ring-black/20"
          >
            {isZh ? '建立导师档案' : 'Create your tutor profile'}
            <ArrowRight className="h-4 w-4 shrink-0" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TeachCTASection;
